import { dmnStorage } from "../dmnStorage";

const storageKey = "gridConfig";

export type ColourCardsBy = "type" | "stage";

export type GridConfigDataStorageType = {
  displayZones: boolean;
  displayUnassigned: boolean;
  displayNewAndInProgress: boolean;
  displayLeft: boolean;
  displayCancelled: boolean;
  displayNoShow: boolean;
  displayNewCovers: boolean;
  displayClosedAreas: boolean;
  highlightOverrunningBookings: boolean;
  highlightOverCapacity: boolean;
  colourCardsBy: ColourCardsBy;
  size: number;
  areaPanelWidth: number;
};

export const gridConfigStorageDefault: GridConfigDataStorageType = {
  displayZones: true,
  displayUnassigned: true,
  displayNewAndInProgress: true,
  displayLeft: true,
  displayCancelled: true,
  displayNoShow: true,
  displayNewCovers: true,
  displayClosedAreas: true,
  highlightOverrunningBookings: true,
  highlightOverCapacity: true,
  colourCardsBy: "type",
  size: 5,
  areaPanelWidth: 128
};

export const addGridConfigStorage = async (data: GridConfigDataStorageType) => {
  return await dmnStorage.add(storageKey, data);
};

export const getGridConfigStorage =
  async (): Promise<GridConfigDataStorageType> => {
    const response: GridConfigDataStorageType | undefined =
      await dmnStorage.get(storageKey);

    return response || gridConfigStorageDefault;
  };
